// Shared avatar configuration for the Jobasti platform.
//
// Each avatar belongs to a `category`:
//   - 'animal' : Illustrated cartoon animals served as PNGs from /public/avatars
//   - 'human'  : Illustrated business-professional faces generated by DiceBear's
//                "notionists" SVG style (free, deterministic — same seed = same image)
//
// Animal set is gender-neutral by design (the cartoon style works for any user);
// the human set leans toward female business looks per recruiter requests.
export const AVATARS = [
  // ── Animal set ────────────────────────────────────────────────
  // Gender-neutral / male-coded
  { id: 'fox',    label: 'Fox',    url: '/avatars/fox.png',    category: 'animal' },
  { id: 'bear',   label: 'Bear',   url: '/avatars/bear.png',   category: 'animal' },
  { id: 'owl',    label: 'Owl',    url: '/avatars/owl.png',    category: 'animal' },
  { id: 'cat',    label: 'Cat',    url: '/avatars/cat.png',    category: 'animal' },
  { id: 'dog',    label: 'Dog',    url: '/avatars/dog.png',    category: 'animal' },
  { id: 'rabbit', label: 'Rabbit', url: '/avatars/rabbit.png', category: 'animal' },
  // Female-coded business mascots (generated to match the existing illustrated style)
  { id: 'lioness',  label: 'Lioness',  url: '/avatars/lioness.png',  category: 'animal' },
  { id: 'deer',     label: 'Deer',     url: '/avatars/deer.png',     category: 'animal' },
  { id: 'swan',     label: 'Swan',     url: '/avatars/swan.png',     category: 'animal' },
  { id: 'squirrel', label: 'Squirrel', url: '/avatars/squirrel.png', category: 'animal' },
  { id: 'flamingo', label: 'Flamingo', url: '/avatars/flamingo.png', category: 'animal' },
  { id: 'panda',    label: 'Panda',    url: '/avatars/panda.png',    category: 'animal' },

  // ── Human set — female business-professional ─────────────────
  { id: 'emma',      label: 'Emma',      category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Emma&backgroundColor=dbeafe&radius=50' },
  { id: 'sofia',     label: 'Sofia',     category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Sofia&backgroundColor=fce7f3&radius=50' },
  { id: 'olivia',    label: 'Olivia',    category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Olivia&backgroundColor=fef3c7&radius=50' },
  { id: 'ava',       label: 'Ava',       category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Ava&backgroundColor=d1fae5&radius=50' },
  { id: 'mia',       label: 'Mia',       category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Mia&backgroundColor=e0e7ff&radius=50' },
  { id: 'charlotte', label: 'Charlotte', category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Charlotte&backgroundColor=ffe4e6&radius=50' },
  { id: 'isabella',  label: 'Isabella',  category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Isabella&backgroundColor=cffafe&radius=50' },
  { id: 'amelia',    label: 'Amelia',    category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Amelia&backgroundColor=ede9fe&radius=50' },
  { id: 'harper',    label: 'Harper',    category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Harper&backgroundColor=fef3c7&radius=50' },
  { id: 'aria',      label: 'Aria',      category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Aria&backgroundColor=ffedd5&radius=50' },
  { id: 'luna',      label: 'Luna',      category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Luna&backgroundColor=e0f2fe&radius=50' },
  { id: 'zoe',       label: 'Zoe',       category: 'human', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Zoe&backgroundColor=fae8ff&radius=50' },
];

export const AVATAR_CATEGORIES = [
  { id: 'animal', label: 'Animals', emoji: '🐾' },
  { id: 'human',  label: 'People',  emoji: '👤' },
];

export const getAvatarUrl = (avatarId) => {
  const avatar = AVATARS.find((a) => a.id === avatarId);
  return avatar?.url || null;
};

export const DEFAULT_AVATAR_ID = 'fox';
